import { useGetCurrentPublishedActivity } from "../../hooks/useActivities";
import { OldVersionMessageBar } from "../OldVersionMessageBar";

interface OldActivityVersionMessageBarProps {
  activityId: string;
}

export const OldActivityVersionMessageBar = (
  props: OldActivityVersionMessageBarProps
) => {
  const { activityId } = props;

  const {
    data: currentVersion,
    isLoading: isCurrentLoading,
    isRefetching: isCurrentRefetching,
  } = useGetCurrentPublishedActivity(activityId);

  return (
    <OldVersionMessageBar
      type="activity"
      currentVersion={{
        versionId: currentVersion?.versionId ?? "",
        title: currentVersion?.title ?? "",
      }}
      isLoading={isCurrentLoading}
      isRefetching={isCurrentRefetching}
    />
  );
};
